"use client";

import { selectLoginStatus, useAppSelector } from "@repo/web-store";
import { twMerge } from "tailwind-merge";

type ConditionalSubtextProps = {
  subtext?: string;
  className?: string;
};



const ConditionalSubtext = ({ subtext, className }: ConditionalSubtextProps) => {
  const loginStatus = useAppSelector(selectLoginStatus);
  const isLoggedIn = loginStatus === "success" || loginStatus === "perpetual";

  if (isLoggedIn) {
    return null;
  }

  return (
    <p className={twMerge("text-[12px] leading-[16px] font-[400px] text-[#666666]", className)}>
      {subtext ?? ""}
    </p>
  );
};

export default ConditionalSubtext;
